import React from "react";
import styled from "styled-components";
import { get as lodashGet } from "lodash";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import CouponListItem from "src/components/Coupon/CouponListItem";

const Wrapper = styled.div`
  .no_data {
    margin: 40px 0 50px;
    font-size: 20px;
    line-height: 1.3;
    width: 100vw;
  }
`;

const AvailableCouponList = ({ getCouponById }) => {
  const couponsList = useSelector((state) => state.ajax.availableCoupon);
  const formatCouponList = lodashGet(couponsList, ["data", "rows"], []);

  console.log(couponsList);

  return (
    <Wrapper>
      {formatCouponList.length < 1 ? (
        <Typography className="no_data" color="primary">
          目前沒有優惠券
        </Typography>
      ) : (
        formatCouponList.map((coupon) => (
          <CouponListItem
            getCouponById={getCouponById}
            key={coupon.id}
            isExchanged={false}
            {...coupon}
          />
        ))
      )}
    </Wrapper>
  );
};

export default AvailableCouponList;
